import axios from 'axios';
import authHeader from './auth-header';
import Jsona from "jsona";

const API_URL = process.env.VUE_APP_API_BASE_URL;

const jsona = new Jsona();

const SIGNAL_API = `${API_URL}/backoffice/signals`;

async function getAll(params) {
    const response = await axios.get(SIGNAL_API, { params: params, headers: authHeader() });
    return response.data;
}

async function get(id) {
    const response = await axios.get(SIGNAL_API + '/' + id, { headers: authHeader() });
    return response.data;
}

async function create(params) {
    const response = await axios.post(SIGNAL_API, params, { headers: authHeader() });
    return jsona.deserialize(response.data);
}

async function update(params, id) {
    const response = await axios.put(SIGNAL_API + "/" + id, params, { headers: authHeader() });
    return jsona.deserialize(response.data);
}
  
async function deleteAction(id) {
    const response = await axios.delete(SIGNAL_API + '/' + id, { headers: authHeader() });
    return response.data;
}

export default {
    getAll,
    update,
    create,
    get,
    delete: deleteAction,
};